"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var response_1 = require("../response/response");
var IotizeLWM2MResponseConverter = /** @class */ (function () {
    function IotizeLWM2MResponseConverter() {
    }
    IotizeLWM2MResponseConverter.prototype.decode = function (frame) {
        var response = new response_1.Response(frame);
        return response;
    };
    IotizeLWM2MResponseConverter.prototype.encode = function (response) {
        return response.toBytes();
    };
    return IotizeLWM2MResponseConverter;
}());
exports.IotizeLWM2MResponseConverter = IotizeLWM2MResponseConverter;
